import { useQuery } from "@tanstack/react-query";

import { getFootprintingFarmRetailers, getFootprintingFarmRetailersAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_FARM_RESOURCE_RETAILERS } from "consts";

export const useGetFootprintingFarmRetailers = (farmId: string) => {
  const isAdmin = getEnvironment().admin;
  const queryFn = isAdmin ? getFootprintingFarmRetailersAdmin : getFootprintingFarmRetailers;

  return useQuery({
    queryKey: [FOOTPRINTING_FARM_RESOURCE_RETAILERS, farmId],
    queryFn: () => queryFn(farmId),
    enabled: !!farmId,
    gcTime: 0,
  });
};
